import { Icon, IconProps } from "@chakra-ui/react";

const DotsGridIcon = (props: IconProps) => {
	return (
		<Icon
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M12.6667 4.99998C13.1269 4.99998 13.5 4.62688 13.5 4.16665C13.5 3.70641 13.1269 3.33331 12.6667 3.33331C12.2064 3.33331 11.8333 3.70641 11.8333 4.16665C11.8333 4.62688 12.2064 4.99998 12.6667 4.99998Z"
				stroke="currentColor"
				strokeWidth="1.66667"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M12.6667 10.8333C13.1269 10.8333 13.5 10.4602 13.5 9.99998C13.5 9.53974 13.1269 9.16665 12.6667 9.16665C12.2064 9.16665 11.8333 9.53974 11.8333 9.99998C11.8333 10.4602 12.2064 10.8333 12.6667 10.8333Z"
				stroke="currentColor"
				strokeWidth="1.66667"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M12.6667 16.6666C13.1269 16.6666 13.5 16.2936 13.5 15.8333C13.5 15.3731 13.1269 15 12.6667 15C12.2064 15 11.8333 15.3731 11.8333 15.8333C11.8333 16.2936 12.2064 16.6666 12.6667 16.6666Z"
				stroke="currentColor"
				strokeWidth="1.66667"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M6.83333 4.99998C7.29357 4.99998 7.66667 4.62688 7.66667 4.16665C7.66667 3.70641 7.29357 3.33331 6.83333 3.33331C6.3731 3.33331 6 3.70641 6 4.16665C6 4.62688 6.3731 4.99998 6.83333 4.99998Z"
				stroke="currentColor"
				strokeWidth="1.66667"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M6.83333 10.8333C7.29357 10.8333 7.66667 10.4602 7.66667 9.99998C7.66667 9.53974 7.29357 9.16665 6.83333 9.16665C6.3731 9.16665 6 9.53974 6 9.99998C6 10.4602 6.3731 10.8333 6.83333 10.8333Z"
				stroke="currentColor"
				strokeWidth="1.66667"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M6.83333 16.6666C7.29357 16.6666 7.66667 16.2936 7.66667 15.8333C7.66667 15.3731 7.29357 15 6.83333 15C6.3731 15 6 15.3731 6 15.8333C6 16.2936 6.3731 16.6666 6.83333 16.6666Z"
				stroke="currentColor"
				strokeWidth="1.66667"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Icon>
	);
};

export default DotsGridIcon;
